"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSettings = void 0;
const EventDto_1 = require("../dto/EventDto");
class EventSettings {
    constructor(timeZone, timeZoneType, scheduleDaysType, showScheduleOnMainPage) {
        this.timeZone = timeZone;
        this.timeZoneType = timeZoneType;
        this.scheduleDaysType = scheduleDaysType;
        this.showScheduleOnMainPage = showScheduleOnMainPage;
    }
    get isScheduleDaysTypeSeparate() {
        return this.scheduleDaysType === EventDto_1.ScheduleDaysTypeDto.SEPARATE;
    }
    get isScheduleDaysTypeStacked() {
        return this.scheduleDaysType === EventDto_1.ScheduleDaysTypeDto.STACKED;
    }
    static fromDto(dto) {
        return new EventSettings(dto.timeZone, dto.timeZoneType ? dto.timeZoneType : EventDto_1.TimeZoneTypeDto.LOCAL, dto.scheduleDaysType ? dto.scheduleDaysType : EventDto_1.ScheduleDaysTypeDto.SEPARATE, dto.hasOwnProperty('showScheduleOnMainPage') ? dto.showScheduleOnMainPage : true);
    }
}
exports.EventSettings = EventSettings;
EventSettings.TITLE_TIME_ZONE = "timeZone";
EventSettings.TITLE_TIME_ZONE_TYPE = "timeZoneType";
EventSettings.TITLE_SCHEDULE_DAYS_TYPE = "scheduleDaysType";
EventSettings.TITLE_SHOW_SCHEDULE_ON_MAIN_PAGE = "showScheduleOnMainPage";
EventSettings.DEFAULT = new EventSettings("Europe/Moscow", EventDto_1.TimeZoneTypeDto.LOCAL, EventDto_1.ScheduleDaysTypeDto.SEPARATE, true);
